import { loadStripe } from '@stripe/stripe-js/pure';
import { type Stripe } from '@stripe/stripe-js';
import config from '@/globals/config.js';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = loadStripe(config.STRIPE_KEY);
  }
  return stripePromise;
}
